import { useMemo } from "react";
import { BetSlipMode } from "../types/enums";

interface UseCalculateOddsProps {
  selections: IBetSlipSelection[];
  betBuilderOdds?: IBetBuilderTotalOdds[];
  mode: BetSlipMode;
}

export const useCalculateOdds = ({
  selections,
  betBuilderOdds = [],
  mode,
}: UseCalculateOddsProps) => {
  const totalOdds = useMemo(() => {
    // Only calculate for combo mode
    if (mode !== BetSlipMode.Combo) {
      return 0;
    }

    let odds = 1;

    // Calculate odds from bet builder selections
    if (betBuilderOdds && betBuilderOdds.length > 0) {
      betBuilderOdds.forEach((bbOdd) => {
        odds *= bbOdd.odd || 1;
      });
    }

    // Calculate odds from regular selections
    selections.forEach((selection) => {
      odds *= selection.oddPrice || 1;
    });

    return Number(odds.toFixed(2));
  }, [selections, betBuilderOdds, mode]);

  return totalOdds;
};
